<template>
    <div class="index-container product-search">
        <top-section>
            {{ __('strings.discount.discount_management') }}
            <template v-slot:buttons>
                <b-button
                    type="is-primary"
                    class="is-uppercase"
                    :label="__('strings.discount.discount_status')"
                    @click="toggleDiscountStatusModal"
                ></b-button>
                <b-button
                    type="is-primary"
                    class="is-uppercase ml-4"
                    :label="__('strings.discount.discount_program')"
                    @click="toggleDiscountProgramModal"
                ></b-button>
            </template>
        </top-section>
        <portal to="sidebar">
            <section class="inner-content product-search">
                <b-tabs type="is-boxed">
                    <b-tab-item :label="__('strings.product.filters')">
                        <product-side-search
                            :brands="filters.brands"
                            :seasons="filters.seasons"
                            :categories="filters.categories"
                            :genders="filters.genders"
                            :retailers="filters.retailers"
                            :stocks="filters.stocks"
                            :filters="inputs"
                            @handleProductSearch="handleProductSearch"
                        ></product-side-search>
                    </b-tab-item>
                    <b-tab-item :label="__('strings.product.search_by_sku')">
                        <product-search-by-sku
                            :filters="inputs"
                            @handleProductSearch="handleProductSearch"
                        ></product-search-by-sku>
                    </b-tab-item>
                </b-tabs>
            </section>
        </portal>

        <section class="inner-content section-table">
            <store-switcher route-name="sales.discount.planner" :route-params="{}" use-query send-website></store-switcher>
            <b-table :data="products.data"
                     :total="products.total"
                     :current-page="products.current_page"
                     :per-page="products.per_page"
                     :loading="tableShouldLoad"
                     paginated
                     backend-pagination hoverable narrowed
                     striped checkable scrollable
                     :checked-rows.sync="checkedRows"
                     @page-change="changePage" @click="handleRowClick" @check-all="handleHeaderCheckboxClick">
                <b-table-column label="Thumbnail" width="80" v-slot="props" centered>
                    <img class="thumbnail" :src="props.row.thumbnail">
                </b-table-column>
                <b-table-column width="250" label="Name" v-slot="props">
                    {{ props.row.name }}
                </b-table-column>
                <b-table-column width="90" label="Sku" v-slot="props" centered>
                    {{ props.row.sku }}
                </b-table-column>
                <b-table-column width="100" label="Brand" v-slot="props">
                    {{ props.row.brand.name }}
                </b-table-column>
                <b-table-column width="80" label="Color" v-slot="props">
                    {{ props.row.color }}
                </b-table-column>
                <b-table-column width="80" label="Season" v-slot="props">
                    {{ props.row.season.name }}
                </b-table-column>
                <b-table-column width="180" label="Categories" v-slot="props">
                    {{ getProductCategories(props.row) }}
                </b-table-column>
                <b-table-column width="80" v-for="retailer in filters.retailers.data" :key="'price-'+retailer.id"  :label="retailer.name + ' Price'" centered v-slot="props">
                    {{ getProductPrice(props.row, retailer) }}
                </b-table-column>
                <b-table-column  width="80" v-for="retailer in filters.retailers.data" :key="'special-price-'+retailer.id"  :label="retailer.name + ' Special Price'" centered v-slot="props">
                    {{ getProductSpecialPrice(props.row, retailer) }}
                </b-table-column>
                <b-table-column  width="75" label="Overwiew" v-slot="props" centered>
                    <b-button @click="handleRowClick(props.row)" size="is-small" type="is-primary">Show</b-button>
                </b-table-column>
            </b-table>
        </section>

        <discount-product-footer
            :number_of_selected_products="productIdsToAdd.length"
            :number_of_total_products="products.total"
            @toggleAddDiscountModal="toggleAddDiscountModal"
            @openUploadModal="showUploadModal = true" @createProductPriceExport="handleCreateProductPriceExport"
            @openExportsModal="showExportFilesModal = true"
            :is-loading="tableShouldLoad" :retailers="filters.retailers.data"></discount-product-footer>

        <b-modal
            v-model="isAddDiscountModalActive"
            has-modal-card
            trap-focus
            :destroy-on-hide="true"
            aria-role="dialog"
            aria-modal
        >
            <discount-product-add-new-discount
                :websites="websites"
                :products="productIdsToAdd"
                :retailers="filters.retailers.data"
                @toggleAddDiscountModal="toggleAddDiscountModal"
                @handleAddNewDiscountSubmit="handleAddNewDiscountSubmit"
            ></discount-product-add-new-discount>
        </b-modal>

        <b-modal
            v-model="isDiscountStatusModalActive"
            has-modal-card
        >
            <discount-product-discount-status
                :websites="websites"
                @toggleDiscountStatusModal="toggleDiscountStatusModal"
            >

            </discount-product-discount-status>
        </b-modal>

        <b-modal
            v-model="isDiscountProgramModalActive"
            has-modal-card
        >
            <discount-product-discount-program
                @toggleDiscountProgramModal="toggleDiscountProgramModal"></discount-product-discount-program>
        </b-modal>

        <b-modal v-model="showModalPriceInfoModal" has-modal-card destroy-on-hide>
            <discount-price-website-info @close="showModalPriceInfoModal = false"
                                         :retailers="filters.retailers.data"
                                         :product="selectedProduct"></discount-price-website-info>
        </b-modal>

        <b-modal v-model="showUploadModal" has-modal-card destroy-on-hide>
            <discount-price-upload-file @uploaded="importUploaded" @close="showUploadModal = false" :retailers="filters.retailers.data"></discount-price-upload-file>
        </b-modal>

        <b-modal
            v-model="showExportFilesModal"
            has-modal-card destroy-on-hide
        >
            <discount-product-export-files
                @close="showExportFilesModal = false"></discount-product-export-files>
        </b-modal>
    </div>
</template>

<script>
import _ from 'lodash'

export default {
    data() {
        return {
            websites: [],
            tableShouldLoad: true,
            filtersLoaded: false,
            filters: {
                brands: {
                    toRetrieve: true,
                    model: 'brand',
                    input: 'brand_id'
                },
                genders: {
                    toRetrieve: true,
                    model: 'gender',
                    input: 'gender_id'
                },
                seasons: {
                    toRetrieve: true,
                    model: 'season',
                    input: 'season_id'
                },
                categories: {
                    toRetrieve: true,
                    model: 'category',
                    input: 'category_id'
                },
                retailers: {
                    toRetrieve: true,
                    model: 'retailer',
                    input: 'retailers'
                },
                stocks: {
                    data:[
                        {
                            id: 0,
                            name: "Out of Stock",
                        },
                        {
                            id: 1,
                            name: "In Stock",
                        }]
                },
            },
            inputs: {
                retailers: [],
                in_stock: [],
                brand_id: [],
                gender_id: [],
                category_id: [],
                parent_category_id: undefined,
                sub_category_id: undefined,
                season_id: [],
                sku: [],
                page: undefined,
            },
            products: {
                current_page: undefined,
                data: [],
                first_page_url: undefined,
                from: undefined,
                last_page: undefined,
                last_page_url: undefined,
                next_page_url: undefined,
                path: undefined,
                per_page: undefined,
                prev_page_url: undefined,
                to: undefined,
                total: 0
            },
            checkedRows: [],
            productIdsToAdd: [],
            isAddDiscountModalActive: false,
            isDiscountStatusModalActive: false,
            isDiscountProgramModalActive: false,
            showModalPriceInfoModal: false,
            selectedProduct: null,
            showUploadModal: false,
            showExportFilesModal: false
        };
    },
    beforeMount(){
        axios.get("/website/index").then(response => {
            this.websites = response.data;
            this.websites.splice(0, 1);
        });
        // Retrieve all filters
        for (let [filterKey, filterProp] of Object.entries(this.filters)) {
            if(filterProp.toRetrieve){
                this.filters[filterKey] = {
                    ...filterProp,
                    data: [],
                    loading: true,
                    error: null,
                    input: ''
                };
                this.fetchFilters(filterKey, filterProp);
            }
        }
        this.filtersLoaded = true;
        let searchParams = new URLSearchParams(window.location.search);
        let query = {};
        for (let [key, value] of searchParams.entries()) {
            query[key] = searchParams.get(key).split(",").map((el)=>eval(el));
        }
        this.assignData(query);
        // Set the current page from query string
        this.inputs.page = searchParams.get("page") ? eval(searchParams.get("page")) : 1;
    },
    mounted() {
        this.handleProductSearch();
    },
    methods: {
        importUploaded(message) {
            this.showUploadModal = false;
            this.toaster(message, 'success');
        },
        handleRowClick(product) {
            this.selectedProduct = product;
            this.showModalPriceInfoModal = true;
        },
        handleHeaderCheckboxClick(items) {
            if (items.length) {
                let searchParams = new URLSearchParams(window.location.search);
                this.tableShouldLoad = true
                axios.get('/discount/products/ids', {params: searchParams})
                    .then(response => this.productIdsToAdd = response.data)
                    .finally(() => this.tableShouldLoad = false)
            }
        },
        /**
         * This method is used to retrieve programmatically the data for filters
         */
        fetchFilters(filterKey, filterProp) {
            this.filters[filterKey].loading = true;

            // Set the endpoint to fetch
            let endpoint = filterProp.model;
            endpoint += (filterProp.hasOwnProperty('filters') || this.filteredProductIds) ? '/filter' : '/index';

            // Build the query string
            const query = new URLSearchParams();
            query.set('paginate', 'false');
            if(filterProp.hasOwnProperty('filters')) {
                for (let [key, value] of Object.entries(filterProp.filters)) {
                    query.set(key, value);
                }
            }
            if(this.filteredProductIds) {
                query.set('table_column', this.filters[filterKey].input);
                query.set('product_ids', this.filteredProductIds.toString());
            }

            // Fetch the filter
            axios.get(endpoint, {params: query})
                .then(response => {
                    this.filters[filterKey].data = response.data;
                })
                .catch(error => {
                    this.filters[filterKey].error = error.response.data.message;
                })
                .finally(() => {
                    this.filters[filterKey].loading = false
                })
        },
        toggleAddDiscountModal() {
            this.isAddDiscountModalActive = !this.isAddDiscountModalActive;
        },
        toggleDiscountStatusModal() {
            this.isDiscountStatusModalActive = !this.isDiscountStatusModalActive;
        },
        toggleDiscountProgramModal() {
            this.isDiscountProgramModalActive = !this.isDiscountProgramModalActive;
        },
        handleProductSearch(filters) {
            this.inputs = {...this.inputs, ...filters};
            if (this.$route.query.hasOwnProperty('store')) {
                this.inputs['store'] = this.$route.query.store;
            }

            if (this.$route.query.hasOwnProperty('website')) {
                this.inputs['website'] = this.$route.query.website;
            }
            // Build search params
            let searchParams = new URLSearchParams(window.location.search);
            let query = {};
            let queryString = {};
            for (let [key, value] of Object.entries(this.inputs)) {
                if(value===undefined || value.length === 0) continue;
                query[key] = value;
                searchParams.set(key, value);
                queryString[key] = Array.isArray(value)? value.join(",") : value;
            }

            // Replace the old query string
            try {
                this.$router.push({ query: queryString }).catch(()=>{});
            } catch (error) {

            }

            this.tableShouldLoad = true;
            axios.get('/product/filter', {params: searchParams})
                .then(response => {
                    this.products = response.data.products;
                    this.filteredProductIds = response.data.product_ids;
                })
                .finally(() => {
                    this.tableShouldLoad = false;
                    window.scrollTo({top: 0, behavior: 'smooth'})
                })
        },
        handleAddNewDiscountSubmit(data) {
            axios.post('/discount/plan', data)
                .then(() => {
                    this.checkedRows = [];
                    this.$buefy.snackbar.open({
                        message: 'Il piano è stato aggiunto alla coda',
                        type: 'is-success',
                        position: 'is-bottom-right',
                        actionText: 'Ok',
                    })
                })
                .catch(error => {
                    this.$buefy.snackbar.open({
                        message: 'non è stato possibile aggiungere il piano alla coda:'+error,
                        type: 'is-error',
                        position: 'is-bottom-right',
                        actionText: 'Ok',
                    })
                });
        },
        changePage(target) {
            this.inputs.page = target;
            this.handleProductSearch();
        },
        getProductCategories(product) {
            return _.map(product.categories, 'name').join(', ');
        },
        getProductPrice(product, retailer) {
            return this.getProductPriceByTypeAndRetailer(product, 'price', retailer);
        },
        getProductSpecialPrice(product, retailer) {
            return this.getProductPriceByTypeAndRetailer(product, 'special_price', retailer);
        },
        getProductPriceByTypeAndRetailer(product, type, retailer) {
            let price = _.find(product.price, {retailer_id: retailer.id})
            if (price && price.hasOwnProperty(type) && price[type]) {
                let website = _.find(this.websites, {id: price.website_id})
                let currency = _.find(website.currencies, {retailer_id: retailer.id})
                if(currency) {
                    return price[type] + ' ' + currency.currency;
                }
                return price[type];
            }
            return null;
        },
        getProductThumbnail(product) {
            let media = null;
            if (product.media.length) {
                media = product.media[0]
            }
            return media ? media.url : null;
        },
        assignData(data) {
            for (let key of Object.keys(this.inputs)) {
                if(data.hasOwnProperty(key)) {
                    this.inputs[key] = data[key];
                }
            }
        },
        handleCreateProductPriceExport(retailer) {
            this.tableShouldLoad = true
            axios.get(`/discount/products/export/${retailer.id}`)
                .then(response => this.toaster(response.data, 'success'))
                .catch(error => this.toaster(error.response.data, 'error'))
                .finally(() => this.tableShouldLoad = false)
        },
        toaster(message, type) {
            this.$buefy.snackbar.open({
                message,
                type,
                position: 'is-bottom-right',
                actionText: 'Ok',
            })
        }
    },
    watch: {
        $route(to, from) {
            this.handleProductSearch(to.query)
        },
        checkedRows() {
            this.productIdsToAdd = _.map(this.checkedRows, 'id')
        }
    }
}
</script>
